// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/fonts/Montserrat-Bold/montserrat-bold.css
// module id = 2061
// module chunks = 0